import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractAssetComponent } from '../abstract-asset.component';
import { AssetFamilyTree } from 'src/app/common/models/ai-reports/shared/assets';

@Component({
  selector: 'app-asset-family-tree',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './asset-family-tree.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetFamilyTreeComponent extends AbstractAssetComponent<AssetFamilyTree> {}